import { IconButton, InputAdornment, TextField } from '@material-ui/core'
import { Field } from 'formik'
import { Smile } from 'lucide-react'
import { useState, useEffect, useRef } from 'react'
import EmojiOptions from '../EmojiOptions'
import { useStyles } from './style'

export function InputField({
  name = '',
  type = '',
  label,
  required,
  emoji = false,
  onChange,
  ...rest
}) {
  const classes = useStyles()
  const [isFocused, setIsFocused] = useState(false)
  const [showEmoji, setShowEmoji] = useState(false)

  const inputRef = useRef(null)

  useEffect(() => {}, [showEmoji])

  const insertEmojiAtCursor = (currentValue, nativeEmoji, setValueCallback) => {
    const input =
      inputRef.current?.querySelector('input') ||
      inputRef.current?.querySelector('textarea')

    if (input) {
      const start = input.selectionStart
      const end = input.selectionEnd

      const textBefore = currentValue.substring(0, start)
      const textAfter = currentValue.substring(end)

      const newValue = textBefore + nativeEmoji + textAfter

      setValueCallback(newValue)

      setTimeout(() => {
        input.focus()
        const newCursorPos = start + nativeEmoji.length
        input.setSelectionRange(newCursorPos, newCursorPos)
      }, 0)
    } else {
      setValueCallback(currentValue + nativeEmoji)
    }
  }

  const mergedEndAdornment = (rest.InputProps?.endAdornment || emoji) ? (
    <>
      {rest.InputProps?.endAdornment}
      {emoji && (
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle emoji picker"
            onClick={() => setShowEmoji(prev => !prev)}
            className={classes.iconButton}
          >
            <Smile size={20} />
          </IconButton>
        </InputAdornment>
      )}
    </>
  ) : undefined

  if (onChange) {
    const handleAddEmoji = e => {
      const currentValue = rest.value ?? ''
      insertEmojiAtCursor(currentValue, e.native, val => {
        onChange({ target: { name, value: val } })
      })
    }

    return (
      <div className={classes.root}>
        {label && (
          <label
            htmlFor={name}
            className={`${classes.inputLabel} ${
              isFocused ? classes.inputLabelFocused : ''
            }`}
          >
            {label}
          </label>
        )}
        <TextField
          {...rest}
          ref={inputRef}
          name={name}
          type={type}
          variant="outlined"
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={e => setIsFocused(false)}
          className={classes.inputField}
          InputProps={{
            ...rest.InputProps,
            endAdornment: mergedEndAdornment
          }}
        />
        {emoji && showEmoji && (
          <EmojiOptions
            showEmoji={showEmoji}
            setShowEmoji={setShowEmoji}
            handleAddEmoji={handleAddEmoji}
            disabled={rest.disabled}
          />
        )}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {label && (
        <label
          htmlFor={name}
          className={`${classes.inputLabel} ${
            isFocused ? classes.inputLabelFocused : ''
          }`}
        >
          {label}
        </label>
      )}
      <Field name={name}>
        {({ field, form }) => {
          const handleAddEmoji = e => {
            if (field.value) {
              form.setFieldValue(name, field.value + e.native)
            } else {
              form.setFieldValue(name, e.native)
            }
          }

          return (
            <>
              <TextField
                {...rest}
                {...field}
                type={type}
                variant="outlined"
                onFocus={() => setIsFocused(true)}
                onBlur={e => {
                  field.onBlur(e)
                  setIsFocused(false)
                }}
                className={classes.inputField}
                InputProps={{
                  ...rest.InputProps,
                  endAdornment: mergedEndAdornment 
                }}
              />
              {emoji && showEmoji && (
                <EmojiOptions
                  showEmoji={showEmoji}
                  setShowEmoji={setShowEmoji}
                  handleAddEmoji={handleAddEmoji}
                  disabled={rest.disabled}
                />
              )}
            </>
          )
        }}
      </Field>
    </div>
  )
}